import { render, staticRenderFns } from "./ArticlesExternal.vue?vue&type=template&id=6d595cc8"
import script from "./ArticlesExternal.vue?vue&type=script&lang=js"
export * from "./ArticlesExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports